import useIdleTimer from "hooks/useIdleTimer";

const IdleTimer = () => {
  const sessionIdleTimeInMin = 3;

  const { idleModalContext } = useIdleTimer({
    sessionIdleTimeInMs: sessionIdleTimeInMin * 60 * 1000,
    modalIdleTimeInMs: 60 * 1000,
    modalConfig: {
      title: "Session timeout",
      message:
        "You are about to be logged off due to inactivity. Close this modal to stay signed in. ",
    },
  });

  return idleModalContext;
};

export default IdleTimer;
